
const ModalCollectionService = {  
    map: null,
    featureGroup:null, 
    tagGroup:null, 
    originalGeojson  : null,
    userid : null,
    argeojson : [],

    /**
     * Initialise le service .
     * Doit être appelé avant toute autre méthode.
     * @param {geojson} geoJsonMap - geojson des parcelles sélectionner sur la carte principale
     */
    init(geoJsonMap,userid) {
        this.featureGroup = L.featureGroup();
        this.tagGroup = L.featureGroup();
        this.userid = userid;
        this.argeojson = [];
        this.map = L.map('map_modal',{
            maxZoom: 18,
            minZoom: 16,
            zoomControl: false,
            boxZoom: true,
            attributionControl: false,
            dragging: false,
            tap: false
        }).setView([46.63, 2.81], 7);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);

        this.map.invalidateSize();
        this.map.addLayer(this.featureGroup);  
        this.map.addLayer(this.tagGroup);
        this.zoomentite(geoJsonMap);       
    },

    zoomentite(geojson){
        const layer = L.geoJSON(geojson);
        const bounds = layer.getBounds();
        this.map.fitBounds(bounds, { padding: [20, 20] });
    },

    async fetchParcelle(urlApi,idpar) {
        try {
          const response = await fetch(`${urlApi}parcelle/${idpar}?skipGeometry=false`);
          if (!response.ok) {
            const errData = await response.json();
            throw new Error(errData.message || 'Erreur lors de la récupération');
          }
          return await response.json();
        } catch (err) {
          return [];
        }
    },

    drawParcelle(geojson){
        this.argeojson.push(geojson);
        const result = this.drawParcelleInMap(geojson);
        return result;
    },

    drawParcelleInMap(geojson){
        let result = null;
        let normalizedGeoJSON = geojson;

        if (geojson.type === "Feature") {
            normalizedGeoJSON = {
                type: "FeatureCollection",
                features: [geojson]
            };
        }

        const options = {
            color: "#92bbf4",
            fillColor:"#92bbf4",
            fillOpacity: 0.2,
            opacity: 1,
            weight: 3
        };
        L.geoJSON(normalizedGeoJSON, {
            style:options,
            onEachFeature: (feature, layer) => {
                if(layer.feature.geometry.type === "MultiPolygon" || layer.feature.geometry.type === "Polygon"){
                    const geomtype = 'polygon';
                    const idu = feature.properties?.idu || feature.properties?.id_par;
                    if (feature.properties && idu) {
                        const idpartmp = idu;
                        layer.feature.properties.nomaffichepar = idpartmp.slice(0, 50);
                    }
                    const nomaffichepar = layer.feature.properties.nomaffichepar;
                    this.featureGroup.addLayer(layer);  
                    const newDataAnnotation = this.creatDataAnnotation(options,geomtype,nomaffichepar.slice(0, 50));
                    layer.data = newDataAnnotation;    
                    layer.data.id = layer._leaflet_id;
                    result = {
                        id: layer._leaflet_id,
                        geojson: layer.toGeoJSON(),
                        nom: nomaffichepar.slice(0, 50)
                    };
                }
            }
        });
        return result;
    },

    getListFusion() {

        // Effacer les anciennes couches
        this.featureGroup.clearLayers();

        // Copie des features (on garde seulement les Feature)
        let features = this.argeojson.map(fc => fc.features[0]);
    
        let groupes = [];
        let visited = new Set();
    
        // Fonction pour regrouper récursivement
        const dfs = (idx, groupe) => {
            visited.add(idx);
            groupe.push(features[idx]);
    
            for (let j = 0; j < features.length; j++) {
                if (!visited.has(j)) {
                    if (turf.booleanIntersects(features[idx], features[j])) {
                        dfs(j, groupe);
                    }
                }
            }
        };
    
        // Création des groupes contigus
        for (let i = 0; i < features.length; i++) {
            if (!visited.has(i)) {
                let groupe = [];
                dfs(i, groupe);
                groupes.push(groupe);
            }
        }
    
        // Fusion de chaque groupe
        let resultats = groupes.map(groupe => {
            // Collecte des IDs
            let ids = groupe.map(f => f.properties?.idu || f.properties?.id_par || "");
            let fusion = groupe[0];
    
            for (let i = 1; i < groupe.length; i++) {
                fusion = turf.union(fusion, groupe[i]);
            }
            
            // Ajout des propriétés fusionnées
            fusion.properties = fusion.properties || {};
            fusion.properties.idu = ids.join(",");
            fusion.properties.nomaffichepar = fusion.properties.idu;
    
            return fusion; // Feature GeoJSON fusionnée
        });
        return resultats;
    },    
    
    defusionnerParcelles() {
        // Effacer les anciennes couches
        this.featureGroup.clearLayers();
        return this.argeojson;
    },

    creatDataAnnotation(options,typelay,titre){
        const newDataAnnotation = {
            collection_id: "",
            css: "null",
            measure: false,
            nb_fichier:0,
            observation: titre,
            options: options,
            sogefi_date: new Date().toISOString(),
            sogefi_date_modification: '',
            sogefi_operateur_creation: this.userid ?? null,
            sogefi_operateur_modification: '',
            tag: false,
            titre: titre,
            type: typelay,
        };
        return newDataAnnotation;
    },

    getProperties(entite){
        let retdatalayer;
        this.featureGroup.eachLayer((layer) => {
            if (layer.data.id === entite.id) {
                retdatalayer = layer.data;
            }
        });
        return retdatalayer;
    },

    updatePropertieLayer(updatedForm, idlayer){
        this.featureGroup.eachLayer((layer) => {
            if (layer.data.id === idlayer) {
                const options = {
                    color: updatedForm.polycontourColor,
                    fillColor:updatedForm.polyColor,
                    fillOpacity: updatedForm.polyOpacity,
                    opacity: updatedForm.polycontourOpacity,
                    weight: updatedForm.polycontourEpaisseur
                };                
                layer.setStyle(options);
                layer.data.titre = updatedForm.nomEntite;
                layer.data.options = options;
                layer.data.measure = updatedForm.measure;
                if(updatedForm.measure){
                    this.addMeasureOnLayer(layer);                
                }else{
                    this.removeTagLayer(idlayer);
                }
                
            }
        });
    },

    addMeasureOnLayer(layer) {
        try {
            let measure = '';
              
            this.removeTagLayer(layer.data.id);
    
            // Vérifier la validité du layer
            if (typeof layer.getBounds !== "function") return;
            const bounds = layer.getBounds();
            if (!bounds || !bounds.isValid()) return;
            const latlng = bounds.getCenter();
            
            // Récupérer et aplatir les coordonnées
            let latlngs = layer.getLatLngs();
            while (Array.isArray(latlngs[0])) {
                latlngs = latlngs[0];
            }
    
            if (!latlngs || latlngs.length < 3) {
                console.warn("Latlngs invalides :", latlngs);
                return;
            }
    
            const coordinates = latlngs.map(ll => [ll.lng, ll.lat]);
    
            // fermer le polygone si nécessaire
            if (coordinates[0][0] !== coordinates[coordinates.length - 1][0] ||
                coordinates[0][1] !== coordinates[coordinates.length - 1][1]) {
                coordinates.push(coordinates[0]);
            }
    
            const polygon = turf.polygon([coordinates]);
            const areaM2 = turf.area(polygon); // en m²
        
            measure = areaM2 >= 1_000_000
                ? (areaM2 / 1_000_000).toLocaleString("fr-FR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + ' km²'
                : Math.round(areaM2).toLocaleString("fr-FR") + " m²";
    
            const point = this.map.latLngToLayerPoint(latlng);
            point.y -= 5;
            const newLatLng = this.map.layerPointToLatLng(point);
    
            const htmlString = `<span style="transform: translate(-35%, -65%);
                white-space: nowrap;
                color: #333;
                font-size: 11px;
                display: inline-block;
                position: relative;
                text-shadow: 0px 0px 10px #c7bcbc;
                font-weight: bold;
                background: #ffffff7a;
                padding: 0 2px;">${measure}</span>`;
    
            const tagLayer = L.marker(newLatLng, {
                icon: L.divIcon({
                    className: "tagLabelCtn",
                    html: htmlString
                })
            });
    
            tagLayer.layerType = "tagMarker";
            tagLayer.id = "measureMarker_" + layer.data.id;
            tagLayer.addTo(this.tagGroup);
            this.addMeasureinLineOnLayer(layer);
        } catch (e) {
            console.error("Erreur dans addMeasureOnLayer :", e);
        }
    },    

    addMeasureinLineOnLayer(layer) { 
        if (!layer || typeof layer.getLatLngs !== "function") return;
    
        let latlngs = layer.getLatLngs();
        while (Array.isArray(latlngs[0])) latlngs = latlngs[0];
    
        // fermer le polygone
        latlngs.push(L.latLng(latlngs[0].lat, latlngs[0].lng));
        if (latlngs.length < 2) return;
    
        // --- Étape 1 : créer la liste des segments
        const segments = [];
        for (let i = 0; i < latlngs.length - 1; i++) {
            const start = latlngs[i];
            const end = latlngs[i + 1];
            const p1 = this.map.latLngToLayerPoint(start);
            const p2 = this.map.latLngToLayerPoint(end);
            const dx = p2.x - p1.x;
            const dy = p2.y - p1.y;
            const angleRad = Math.atan2(dy, dx);
            const angleDeg = angleRad * (180 / Math.PI);
            const distance = start.distanceTo(end);
            segments.push({ start, end, angle: angleDeg, length: distance });
        }
    
        // --- Étape 2 : fusionner tous les segments colinéaires connectés
        const tolerance = 5; // tolérance d’angle en degrés
        const merged = [];
    
        let i = 0;
        while (i < segments.length) {
            let current = { ...segments[i] };
            let j = i + 1;
    
            // tant que les segments suivants sont alignés et connectés → fusionner
            while (j < segments.length) {
                const next = segments[j];
                const angleDiff = Math.abs(next.angle - current.angle);
                const isColinear = angleDiff < tolerance || Math.abs(angleDiff - 180) < tolerance;
                const isConnected = next.start.equals(current.end);
    
                if (isColinear && isConnected) {
                    // étendre le segment
                    current.end = next.end;
                    current.length += next.length;
                    j++;
                } else {
                    break; // fin du groupe de segments fusionnés
                }
            }
    
            merged.push(current);
            i = j; // on saute les segments déjà fusionnés
        }
    
        // --- Étape 3 : afficher une mesure pour chaque segment fusionné
        for (let i = 0; i < merged.length; i++) {
            const { start, end, angle, length } = merged[i];
    
            // Milieu du segment fusionné
            const midLat = (start.lat + end.lat) / 2;
            const midLng = (start.lng + end.lng) / 2;
            const midPoint = L.latLng(midLat, midLng);
    
            // Ajustement de rotation pour éviter le texte à l’envers
            let angleDeg = angle;
            if (angleDeg > 90) angleDeg -= 180;
            if (angleDeg < -90) angleDeg += 180;
    
            // Formatage de la distance
            const measure = length >= 1000
                ? (length / 1000).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " km"
                : Math.round(length).toLocaleString("fr-FR") + " m";
    
            // Créer l’icône de texte
            const icon = L.divIcon({
                className: 'line-text-marker',
                html: `<div style="transform: rotate(${angleDeg}deg); white-space: nowrap;">${measure}</div>`
            });
    
            const tagLayer = L.marker(midPoint, { icon, interactive: false });
            tagLayer.layerType = "tagMarker";
            tagLayer.id = "lineMarker_" + i + "_" + layer.data.id;
            tagLayer.addTo(this.tagGroup);
        }
    },     

    removeTagLayer(layerid){
        this.tagGroup.eachLayer( (layertag) => {
            if (layertag.id && layertag.id.endsWith("_" + layerid)) {
                this.tagGroup.removeLayer(layertag);
            }
        });
    },

    getEntiteToAdd() {
        let result = [];
    
        this.featureGroup.eachLayer((layer) => {
            const geojson = layer.toGeoJSON();
            let geom = null;
    
            // Si c’est un Feature unique
            if (geojson.type === "Feature" && geojson.geometry) {
                geom = JSON.stringify(geojson.geometry);
            } 
            // Si c’est un FeatureCollection
            else if (geojson.type === "FeatureCollection" && Array.isArray(geojson.features)) {
                // Fusionner toutes les géométries dans un MultiPolygon (ou autre)
                const allGeoms = geojson.features
                    .map(f => f.geometry)
                    .filter(g => g); // élimine les null éventuels
                if (allGeoms[0].type === "MultiPolygon") {
                    geom = {
                        type: "Polygon",
                        coordinates: allGeoms[0].coordinates[0] // premier polygone
                    };
                } else {
                    geom = allGeoms[0]; // déjà Polygon
                }
                geom = JSON.stringify(geom);
            } 
            // Sinon (sécurité)
            else {
                console.warn("Géométrie inconnue pour le layer :", geojson);
                return; // on saute ce layer
            }
    
            const entite = {
                "titre": layer.data?.titre || "",
                "measure": layer.data?.measure || false,
                "afficher_centroide": false,
                "observation": layer.data?.observation || "",
                "options": JSON.stringify(layer.options || {}),
                "css": null,
                "geom": geom,
                "type": "polygon",
                "tag": false
            };
    
            result.push(entite);
        });
    
        return result;
    },
    
  
}
  
  export default ModalCollectionService;